import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import { ChartTypeOptionsEnum } from '../types'

type ChartTypeSelectorProps = {
  chartType: ChartTypeOptionsEnum
  onChange: (chartType: ChartTypeOptionsEnum) => void
  enablePieChartOption: boolean
}

const CHART_TYPE_LABEL = 'Chart Type'

export const ChartTypeSelector = ({
  chartType,
  onChange,
  enablePieChartOption,
}: ChartTypeSelectorProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()

  const handleChartTypeChange = (value: ChartTypeOptionsEnum) => {
    onChange(value)
    analytics.trackActionCreator(initiatives.Goal_Chart_Chart_Type_Selected)({
      chartType: value,
      role,
      relationship: nonprofitOrgRole,
    })
  }

  return (
    <FormControl>
      <InputLabel id='progressChartSelectorInputSelectChartTypeLabel'>
        {CHART_TYPE_LABEL}
      </InputLabel>
      <Select
        id='progressChartSelectorInputSelectChartType'
        displayEmpty
        label={CHART_TYPE_LABEL}
        labelId='progressChartSelectorInputSelectChartTypeLabel'
        onChange={({ target: { value } }) =>
          handleChartTypeChange(value as ChartTypeOptionsEnum)
        }
        required
        sx={{ height: '40px', minWidth: '120px' }}
        value={chartType}
      >
        <MenuItem value={ChartTypeOptionsEnum.bar}>
          {ChartTypeOptionsEnum.bar}
        </MenuItem>
        <MenuItem value={ChartTypeOptionsEnum.line}>
          {ChartTypeOptionsEnum.line}
        </MenuItem>
        <MenuItem
          value={ChartTypeOptionsEnum.pie}
          disabled={!enablePieChartOption}
        >
          {!enablePieChartOption && (
            <em>{ChartTypeOptionsEnum.pie} (At Least 2 Categories Required)</em>
          )}
          {enablePieChartOption && ChartTypeOptionsEnum.pie}
        </MenuItem>
      </Select>
    </FormControl>
  )
}
